import {
  heroAdjustmentsHorizontal,
  heroArrowDownTray,
  heroArrowLeft,
  heroArrowPath,
  heroArrowUturnLeft,
  heroBars3,
  heroCalendarDays,
  heroCheck,
  heroCheckBadge,
  heroChevronLeft,
  heroChevronRight,
  heroClock,
  heroDocumentArrowDown,
  heroDocumentArrowUp,
  heroExclamationTriangle,
  heroEye,
  heroEyeSlash,
  heroInformationCircle,
  heroLockClosed,
  heroMagnifyingGlass,
  heroMinus,
  heroPaperClip,
  heroPause,
  heroPencil,
  heroPlay,
  heroPlus,
  heroPlusCircle,
  heroScissors,
  heroShare,
  heroShieldCheck,
  heroTrash,
  heroTrophy,
  heroUser,
  heroUserGroup,
  heroVideoCamera,
  heroXMark,
} from '@ng-icons/heroicons/outline';

/**
 * Every heroicon the app renders. Components that pick their icon by name at
 * runtime — snackbars, menu items, confirm modals, header action buttons — cannot
 * declare a static `provideIcons({ ... })`, so they provide this whole set instead.
 * Components with statically known icons keep their own narrow `provideIcons` call.
 */
export const APP_HERO_ICONS = {
  heroDocumentArrowUp,
  heroDocumentArrowDown,
  heroAdjustmentsHorizontal,
  heroArrowDownTray,
  heroArrowLeft,
  heroArrowPath,
  heroArrowUturnLeft,
  heroBars3,
  heroCalendarDays,
  heroCheck,
  heroCheckBadge,
  heroChevronLeft,
  heroChevronRight,
  heroClock,
  heroExclamationTriangle,
  heroEye,
  heroEyeSlash,
  heroInformationCircle,
  heroLockClosed,
  heroMagnifyingGlass,
  heroMinus,
  heroPaperClip,
  heroPause,
  heroPencil,
  heroPlay,
  heroPlus,
  heroPlusCircle,
  heroScissors,
  heroShare,
  heroShieldCheck,
  heroTrash,
  heroTrophy,
  heroUser,
  heroUserGroup,
  heroVideoCamera,
  heroXMark,
};

/**
 * Domain glyphs with no heroicon equivalent (drawing tools, pitch overlay).
 * These stay on `mat-icon` via the Material icon registry.
 */
export const APP_ICONS: { iconName: string; iconPath: string }[] = [
  {
    iconName: 'cmv-oval',
    iconPath: 'assets/icons/oval_icon.svg',
  },
  {
    iconName: 'cmv-line',
    iconPath: 'assets/icons/line_icon.svg',
  },
  {
    iconName: 'cmv-field',
    iconPath: 'assets/icons/field.svg',
  },
];
